
//#region FUNCTION generateHexId
export function generateHexId(length: number = 32): string {
  const safeLen = Math.max(1, Math.floor(length));
  try {
    const host = globalThis as typeof globalThis & { msCrypto?: Crypto };
    const cryptoObj = host.crypto ?? host.msCrypto;

    if (cryptoObj?.getRandomValues) {
      const bytes = new Uint8Array(Math.ceil(safeLen / 2));
      cryptoObj.getRandomValues(bytes);
      return Array.from(bytes, b => b.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, safeLen);
    }
  } catch {
  }

  return Array.from({length: safeLen}, () =>
    Math.floor(Math.random() * 16).toString(16),
  ).join('');
}

//#endregion